import 'jquery';

export default () => {

    $(document).on('click', '.js-accordion-title', function() {
        let $this = $(this);
        if ($this.hasClass('active')) {
            $this.removeClass('active');
            $this.siblings('.content-wrapper').slideUp();
        } else {
            $this.addClass('active');
            $this.siblings('.content-wrapper').slideDown();
            $this.closest('.accordion-item').siblings('.accordion-item').find('.js-accordion-title').removeClass('active');
            $this.closest('.accordion-item').siblings('.accordion-item').find('.content-wrapper').slideUp();
        }

    });





};


// WEBPACK FOOTER //
// ./scripts/modules/accordion.js